import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import logger from "../../utils/logger.utils";
const initialState = {
	isAuthenticated: false,
	isLoading: true,
	user: null,
	token: null,
	error: null,
	message: null
};
export const registerUser = createAsyncThunk(
	'/authentication/admin/register',
	async (data, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.post('/admin/auth/register', data);
			return res.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);
export const loginUser = createAsyncThunk(
	'/authentication/admin/login',
	async (data, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.post('/admin/auth/login', data);
			return res.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);
export const getUser = createAsyncThunk(
	'/authentication/admin/get-user',
	async (_, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.get('/admin/auth/get-user');
			return res.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);

export const updateUser = createAsyncThunk(
	'/authentication/update-user',
	async (data, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.put('/auth/update-user', data);
			return res.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);

export const updatePassword = createAsyncThunk(
	'/authentication/update-password',
	async (data, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.put('/auth/update-password', data);
			return res.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		clearError: (state) => {
			state.error = null;
		},
		clearMessage: (state) => {
			state.message = null;
		},
		logOutUser: (state) => {
			state.isAuthenticated = false;
			state.user = null;
			state.token = null;
			localStorage.removeItem('token');
		}
	},
	extraReducers: (builder) => {
		builder

		// 🔸 Register
		.addCase(registerUser.pending, (state) => {
			state.isLoading = true;
			state.isAuthenticated = false;
			state.user = null;
			state.token = null;
			state.error = null;
		})
		.addCase(registerUser.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload?.message;
		})
		.addCase(registerUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isAuthenticated = true;
			state.user = action.payload.user;
			state.token = action.payload.token;
			state.message = action.payload?.message;
			state.error = null;
			
			localStorage.setItem('token', action.payload.token);
		})

		// 🔸 Login
		.addCase(loginUser.pending, (state) => {
			state.isLoading = true;
			state.isAuthenticated = false;
			state.user = null;
			state.token = null;
			state.error = null;
		})
		.addCase(loginUser.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload?.message;
			logger.error('Login rejected, storing token.', action.payload);
		})
		.addCase(loginUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isAuthenticated = true;
			state.user = action.payload.user;
			state.token = action.payload.token;
			state.message = action.payload?.message;
			state.error = null;
			logger.info('Login successful, storing token.', action.payload);
			localStorage.setItem('token', action.payload.token);
		})

		// 🔸 Get User
		.addCase(getUser.pending, (state) => {
			state.isLoading = true;
			state.isAuthenticated = false;
			state.user = null;
			state.token = null;
			state.error = null;
		})
		.addCase(getUser.rejected, (state, action) => {
			state.isLoading = false;
			state.isAuthenticated = false;
			state.error = action.payload?.message;
		})
		.addCase(getUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isAuthenticated = true;
			state.user = action.payload.user;
			state.message = action.payload?.message;
			state.error = null;
		})

		// 🔸 Update User
		.addCase(updateUser.pending, (state) => {
			state.isLoading = true;
			state.isAuthenticated = false;
			state.user = null;
			state.error = null;
		})
		.addCase(updateUser.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload?.message;
		})
		.addCase(updateUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isAuthenticated = true;
			state.user = action.payload?.user;
			state.message = action.payload?.message;
			state.error = null;
			localStorage.setItem('token', action.payload.token);
		})

		// 🔸 Update Password
		.addCase(updatePassword.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		})
		.addCase(updatePassword.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload?.message;
		})
		.addCase(updatePassword.fulfilled, (state, action) => {
			state.isLoading = false;
			state.message = action.payload?.message;
			state.error = null;
		});
	},
});

// 🔹 Exports
export const { clearError, clearMessage, logOutUser } = authSlice.actions;
export default authSlice.reducer;
